import * as React from 'react';
import { translate, InjectedTranslateProps } from 'react-i18next';
import { withExperiments } from '@wix/wix-experiments-react';
import { Groups } from '../Groups';
import { ModalParentNodeRefProvider } from '../../contexts/ModalParentNodeRefContext';
import { TPAComponentsProvider } from 'wix-ui-tpa/TPAComponentsConfig';
import styles from './App.st.css';

export interface Props {
  isUserLoggedIn: boolean;
}

export class AppComponent extends React.Component<
  Props & InjectedTranslateProps
> {
  private readonly ref = React.createRef<HTMLDivElement>();

  render() {
    const { isUserLoggedIn, ...restProps } = this.props;

    return (
      <ModalParentNodeRefProvider value={this.ref.current}>
        <div ref={this.ref} {...styles(styles.root, {}, restProps)}>
          <TPAComponentsProvider value={{ mobile: false }}>
            <Groups isUserLoggedIn={isUserLoggedIn} />
          </TPAComponentsProvider>
        </div>
      </ModalParentNodeRefProvider>
    );
  }
}

export const App = withExperiments<any>(
  translate()(AppComponent),
) as React.ComponentType<Props>;
